<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card class="p-3">
          <b-row>
            <h5 class="m-bold pl-2 w-100 pr-2 mb-2">
              <i class="pt-5px fa-solid fa-heart-circle-plus pull-right primary-color pointer float-right ml-3" aria-hidden="true" title="Recommend Universities"  v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118'" @click="openUnivListModal()"></i>
              <i class="pt-5px fa-solid fa-expand pull-right primary-color pointer ml-3" aria-hidden="true" title="University Shortlist Expand"  v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118'" @click="openExpandedUnivRecoModal()"></i>
              <i class="pt-5px fa fa-cart-plus pull-right primary-color pointer float-right ml-3 cart_icon" aria-hidden="true" title="Student Universities List"  v-if="userData.user_role == 'USERROLE11114' || 'userData.user_role == USERROLE11111' || userData.user_role == 'USERROLE11118'" @click="openStudentUnivChoiceList()"></i>
            </h5>
          </b-row>
          <div v-if="univRecoObjList && univRecoObjList.length > 0" class="accordion" role="tablist">
            <b-card no-body class="mb-2 shadow-sm border-0" v-for="(univObj, index) in univRecoObjList" :key="index">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <div variant="light" class="row m-0 text-left border-0 py-3">
                  <div class="col-12 col-md-9 col-lg-9 mb-2 uniDetail align-items-center">
                    <div class="d-flex align-items-center flex-nowrap w-100">
                      <div class="d-flex align-items-start flex-nowrap w-100">
                        <div class="d-flex align-items-center mr-2 flex-shrink-0" style="margin-top: 3px;">
                          <i
                            class="fa fa-chevron-down small text-muted mr-2 pointer"
                            v-b-toggle="'accordion-' + index"
                          ></i>
                          <i class="fa fa-university primary font-size-18 mr-1"></i>
                        </div>

                        <span class="primary font-weight-bold font-size-16">
                          {{ univObj.org_name }}
                        </span>
                      </div>
                    </div>
                    <b-button class="b-btn m-1 font-size-12 pl-2 pr-2 ml-4 py-1 border-0 text-white"
                      :style="{
                        backgroundColor: admissionStateInfoColors[getMappedStateKey(univObj)] || '#6c757d'
                      }"
                      small
                      @click="openStateChangeModal(univObj)"
                      v-if="userData.user_role === 'USERROLE11111' || userData.user_role === 'USERROLE11118'"
                    >
                      {{ admissionStateInfo[getMappedStateKey(univObj)] || 'Select State' }}
                    </b-button>
                    <span v-if="univObj.org_application_deadline_forstudent" class="ml-4 badge bg-light-warning text-white font-size-12 border-0 px-2 py-2" style="font-weight: 400;">
                      <i class="fa-solid fa-calendar-day mr-1"></i> Deadline: {{ univObj.org_application_deadline_internal | dateFormatDDMMYYYY }}
                    </span>
                  </div>
                  <div class="col-12 col-md-3 col-lg-3 uniIcons text-right text-left-sm">
                    <i class="fa-solid fa-trash-can pointer mr-3 text-primary" title="Remove" @click="removeUnivReco(univObj)"></i>
                    <i class="fa fa-chrome pointer text-primary mr-3" title="Website" @click="goToURL(univObj)"></i>
                    <i class="ri-pencil-line primary-color pointer mr-3" @click="goToOrganisationEdit(univObj)" title="Edit University Profile"
                      v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118'"
                    ></i>
                    <span class="mr-3">
                      <i
                        class="fa fa-check success-color"
                        :class="{ 'pointer': univObj.student_univ_choice_status === 2, 'disabled-icon': univObj.student_univ_choice_status !== 2 }"
                        title="Accept"
                        @click.stop="univObj.student_univ_choice_status === 2 && student_univ_choice_status(univObj, 1)"
                      ></i>

                      <i
                        class="fa fa-close primary-color ml-3"
                        :class="{ 'pointer': univObj.student_univ_choice_status === 2, 'disabled-icon': univObj.student_univ_choice_status !== 2 }"
                        title="Reject"
                        @click.stop="univObj.student_univ_choice_status === 2 && student_univ_choice_status(univObj, 0)"
                      ></i>
                    </span>
                  </div>
                </div>
              </b-card-header>
              <b-collapse :id="'accordion-' + index" accordion="my-accordion" role="tabpanel">
                <b-card-body class="bg-light">
                  <div class="row">
                    <!-- <div class="col-md-4 mt-2 mb-2" v-if ="!univObj.org_profile_id && (userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118')">
                      <div
                        class="iq-card px-4 py-2 h-100 shadow-sm border d-flex align-items-center justify-content-center add-details-card"
                        @click="goToAddOrgProfile(univObj)"
                        style="cursor: pointer; min-height: 150px; border-style: dashed !important; border-width: 2px !important;"
                      >
                        <div class="text-center">
                          <div class="plus-icon-wrapper mb-2">
                            <i class="fa fa-plus-circle text-primary" style="font-size: 3rem;"></i>
                          </div>
                          <h6 class="text-primary">Add Organisation Details</h6>
                        </div>
                      </div>
                    </div> -->
                    <template>
                      <!-- Important Deadlines -->
                      <div class="col-md-4 mb-3">
                        <div class="iq-card px-4 py-2 h-100 shadow-sm border">
                          <h6 class="font-weight-bold text-dark" style="position: relative;">Important Deadlines
                            <div class="mt-1 pull-right" v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118'">
                              <i class="fa-solid fa-calendar pointer text-primary" title="Change Deadlines" @click="openUnivDeadlineModal(univObj)"></i>
                            </div>
                          </h6>
                          <hr class="mt-2">
                          <ol style="padding-inline-start:20px" class="detail_card">
                            <li class="mb-3">
                              <p class="mb-0 information-color">
                                <small>
                                  {{univObj.cour_name}}&nbsp;
                                  <i class="fa fa-arrow-right pointer" v-if="univObj.cour_url && (userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118')" @click="goToUnivCoursePage(univObj.cour_url)"></i>
                                </small>
                              </p>
                              <small>
                                <p class="mb-0 mt-1">App. Deadline (Internal): <span class="information-color"><b>{{ univObj.org_application_deadline_internal|dateFormatDDMMYYYY }}</b></span></p>
                                <div v-html="getApplicationDeadlines(univObj)"></div>
                              </small>
                            </li>
                          </ol>
                        </div>
                      </div>

                      <!-- Available Majors -->
                      <div class="col-md-4 mb-3" v-if="isDataCardVisible(univObj.available_majors)">
                        <div class="iq-card px-4 py-2 h-100 shadow-sm border">
                          <h6 class="font-weight-bold">Available Majors
                            <i v-if="userData.user_role !== 'USERROLE11114'" class="fa fa-pencil text-primary pointer pull-right" @click="openEdit(univObj, 'available_majors', 'Available Majors', 'vueEditor')"></i>
                          </h6>
                          <hr class="mt-2">
                          <span class="text-secondary detail_card" v-html="univObj.available_majors || '<i>No data available</i>'"></span>
                        </div>
                      </div>

                      <!-- Curriculum Design -->
                      <div class="col-md-4 mb-3" v-if="isDataCardVisible(univObj.curriculum_design)">
                        <div class="iq-card px-4 py-2 h-100 shadow-sm border">
                          <h6 class="font-weight-bold"> Curriculum Design
                            <i v-if="userData.user_role !== 'USERROLE11114'" class="fa fa-pencil text-primary pointer pull-right" @click="openEdit(univObj, 'curriculum_design', 'Curriculum Design', 'vueEditor')"></i>
                          </h6>
                          <hr class="mt-2">
                          <span class="text-secondary detail_card" v-html="univObj.curriculum_design || '<i>No data available</i>'"></span>
                        </div>
                      </div>

                      <!-- Structure Size -->
                      <div class="col-md-4 mb-3" v-if="isDataCardVisible(univObj.structure_size)">
                        <div class="iq-card px-4 py-2 h-100 shadow-sm border">
                          <h6 class="font-weight-bold"> Structure Size
                            <i v-if="userData.user_role !== 'USERROLE11114'" class="fa fa-pencil text-primary pointer pull-right" @click="openEdit(univObj, 'structure_size', 'Structure Size', 'vueEditor')"></i>
                          </h6>
                          <hr class="mt-2">
                          <span class="text-secondary detail_card" v-html="univObj.structure_size || '<i>No data available</i>'"></span>
                        </div>
                      </div>

                      <!-- Selectivity -->
                      <div class="col-md-4 mb-3" v-if="isDataCardVisible(univObj.selectivity)">
                        <div class="iq-card px-4 py-2 h-100 shadow-sm border">
                          <h6 class="font-weight-bold"> Selectivity
                            <i v-if="userData.user_role !== 'USERROLE11114'" class="fa fa-pencil text-primary pointer pull-right" @click="openEdit(univObj, 'selectivity', 'Selectivity', 'vueEditor')"></i>
                          </h6>
                          <hr class="mt-2">
                          <span class="text-secondary detail_card" v-html="univObj.selectivity || '<i>No data available</i>'"></span>
                        </div>
                      </div>

                      <!-- Cost -->
                      <div class="col-md-4 mb-3" v-if="isDataCardVisible(univObj.cost)">
                        <div class="iq-card px-4 py-2 h-100 shadow-sm border">
                          <h6 class="font-weight-bold"> Cost
                            <i v-if="userData.user_role !== 'USERROLE11114'" class="fa fa-pencil text-primary pointer pull-right" @click="openEdit(univObj, 'cost', 'Cost', 'vueEditor')"></i>
                          </h6>
                          <hr class="mt-2">
                          <span class="text-secondary detail_card" v-html="univObj.cost || '<i>No data available</i>'"></span>
                        </div>
                      </div>

                      <!-- Weather -->
                      <div class="col-md-4 mb-3" v-if="isDataCardVisible(univObj.weather)">
                        <div class="iq-card px-4 py-2 h-100 shadow-sm border">
                          <h6 class="font-weight-bold"> Weather
                            <i v-if="userData.user_role !== 'USERROLE11114'" class="fa fa-pencil text-primary pointer pull-right" @click="openEdit(univObj, 'weather', 'Weather', 'vueEditor')"></i>
                          </h6>
                          <hr class="mt-2">
                          <span class="text-secondary detail_card" v-html="univObj.weather || '<i>No data available</i>'"></span>
                        </div>
                      </div>

                      <!-- Religiosity -->
                      <div class="col-md-4 mb-3" v-if="isDataCardVisible(univObj.religiosity)">
                        <div class="iq-card px-4 py-2 h-100 shadow-sm border">
                          <h6 class="font-weight-bold"> Religiosity
                            <i v-if="userData.user_role !== 'USERROLE11114'" class="fa fa-pencil text-primary pointer pull-right" @click="openEdit(univObj, 'religiosity', 'Religiosity', 'vueEditor')"></i>
                          </h6>
                          <hr class="mt-2">
                          <span class="text-secondary detail_card" v-html="univObj.religiosity || '<i>No data available</i>'"></span>
                        </div>
                      </div>

                      <!-- Clubs and Extracurriculars -->
                      <div class="col-md-4 mb-3" v-if="isDataCardVisible(univObj.club_extracurriculars)">
                        <div class="iq-card px-4 py-2 h-100 shadow-sm border">
                          <h6 class="font-weight-bold"> Clubs and Extracurriculars
                            <i v-if="userData.user_role !== 'USERROLE11114'" class="fa fa-pencil text-primary pointer pull-right" @click="openEdit(univObj, 'club_extracurriculars', 'Clubs and Extracurriculars', 'vueEditor')"></i>
                          </h6>
                          <hr class="mt-2">
                          <span class="text-secondary detail_card" v-html="univObj.club_extracurriculars || '<i>No data available</i>'"></span>
                        </div>
                      </div>

                      <!-- Demographics -->
                      <div class="col-md-4 mb-3" v-if="isDataCardVisible(univObj.demographics)">
                        <div class="iq-card px-4 py-2 h-100 shadow-sm border">
                          <h6 class="font-weight-bold"> Demographics
                            <i v-if="userData.user_role !== 'USERROLE11114'" class="fa fa-pencil text-primary pointer pull-right" @click="openEdit(univObj, 'demographics', 'Demographics', 'vueEditor')"></i>
                          </h6>
                          <hr class="mt-2">
                          <span class="text-secondary detail_card" v-html="univObj.demographics || '<i>No data available</i>'"></span>
                        </div>
                      </div>

                      <!-- Campus Living Situation -->
                      <div class="col-md-4 mb-3" v-if="isDataCardVisible(univObj.campus_living_situation)">
                          <div class="iq-card px-4 py-2 h-100 shadow-sm border">
                            <h6 class="font-weight-bold"> Campus Living Situation
                              <i v-if="userData.user_role !== 'USERROLE11114'" class="fa fa-pencil text-primary pointer pull-right" @click="openEdit(univObj, 'campus_living_situation', 'Campus Living Situation', 'vueEditor')"></i>
                            </h6>
                            <hr class="mt-2"/>
                            <span class="text-secondary detail_card" v-html="univObj.campus_living_situation || '<i>No data available</i>'"></span>
                          </div>
                      </div>

                      <!-- Social Life Personality -->
                      <div class="col-md-4 mb-3" v-if="isDataCardVisible(univObj.social_life_personality)">
                        <div class="iq-card px-4 py-2 h-100 shadow-sm border">
                          <h6 class="font-weight-bold"> Social Life Personality
                            <i v-if="userData.user_role !== 'USERROLE11114'" class="fa fa-pencil text-primary pointer pull-right" @click="openEdit(univObj, 'social_life_personality', 'Social Life Personality', 'vueEditor')"></i>
                          </h6>
                          <hr class="mt-2">
                          <span class="text-secondary detail_card" v-html="univObj.social_life_personality || '<i>No data available</i>'"></span>
                        </div>
                      </div>

                      <!-- Average Annual Income -->
                      <div class="col-md-4 mb-3" v-if="isDataCardVisible(univObj.average_annual_income)">
                        <div class="iq-card px-4 py-2 h-100 shadow-sm border">
                          <h6 class="font-weight-bold"> Average Annual Income
                            <i v-if="userData.user_role !== 'USERROLE11114'" class="fa fa-pencil text-primary pointer pull-right" @click="openEdit(univObj, 'average_annual_income', 'Average Annual Income', 'vueEditor')"></i>
                          </h6>
                          <hr class="mt-2">
                          <span class="text-secondary detail_card" v-html="univObj.average_annual_income || '<i>No data available</i>'"></span>
                        </div>
                      </div>

                      <!-- Average Graduate Debt -->
                      <div class="col-md-4 mb-3" v-if="isDataCardVisible(univObj.average_graduate_debt)">
                        <div class="iq-card px-4 py-2 h-100 shadow-sm border">
                          <h6 class="font-weight-bold"> Average Graduate Debt
                            <i v-if="userData.user_role !== 'USERROLE11114'" class="fa fa-pencil text-primary pointer pull-right" @click="openEdit(univObj, 'average_graduate_debt', 'Average Graduate Debt', 'vueEditor')"></i>
                          </h6>
                          <hr class="mt-2">
                          <span class="text-secondary detail_card" v-html="univObj.average_graduate_debt || '<i>No data available</i>'"></span>
                        </div>
                      </div>
                      <!-- Job Opportunities -->
                      <div class="col-md-4 mb-3" v-if="isDataCardVisible(univObj.job_opportunities)">
                        <div class="iq-card px-4 py-2 h-100 shadow-sm border">
                          <h6 class="font-weight-bold"> Job Opportunities
                            <i v-if="userData.user_role !== 'USERROLE11114'" class="fa fa-pencil text-primary pointer pull-right" @click="openEdit(univObj, 'job_opportunities', 'Job Opportunities', 'vueEditor')"></i>
                          </h6>
                          <hr class="mt-2">
                          <span class="text-secondary detail_card" v-html="univObj.job_opportunities || '<i>No data available</i>'"></span>
                        </div>
                      </div>
                    </template>
                      </div>
                    </b-card-body>
                  </b-collapse>
            </b-card>
          </div>
          <div v-else>
            Recommended universities not found in the list.&nbsp;
            <span v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118'">
              <span class="pointer primary-color" @click="showUnivList=true">Click here</span> to recommend universities.
            </span>
          </div>
        </iq-card>
      </b-col>
    </b-row>

    <b-modal
      v-model="showStateModal"
      title="Update Admission State"
      hide-footer
      size="md"
    >
      <div class="form-group" v-if="selectedUnivForStateChange">
        <label for="stateSelector" class="font-weight-bold mb-2">
          Select Current Admission Status for {{ selectedUnivForStateChange.org_name }}:
        </label>
        <select id="stateSelector" v-model="targetStateKey" class="form-control">
          <option disabled :value="null">Select State</option>
          <option
            v-for="stateItem in filteredAdmissionStates"
            :key="stateItem.key"
            :value="stateItem.key"
          >
            {{ stateItem.text }} {{ stateItem.key === getMappedStateKey(selectedUnivForStateChange) ? '✓ (Current Mapped)' : '' }}
          </option>
        </select>
      </div>
      <div class="d-flex justify-content-end mt-4">
        <b-button size="sm" variant="secondary" class="mr-2" @click="showStateModal = false">
          Cancel
        </b-button>
        <b-button size="sm" variant="primary" @click="submitStateChange">
          Update State
        </b-button>
      </div>
    </b-modal>

    <b-modal
      v-model="showDeadlineModel"
      scrollable
      :title="cvDeadlineHeader"
      size="xxl"
      class="deadline_modal"
      hide-footer
    >
      <div class="col-md-12 mb-3" v-if="this.org_application_deadlineList[univDeadlineObj.university_id] && Object.keys(this.org_application_deadlineList[univDeadlineObj.university_id]).length > 0">
        <label for="univApplicationDeadlineLabel">{{ univApplicationDeadlineLabel }}</label>&nbsp;<label class="primary-color font-size-16">*</label>
        <select id="univApplicationDeadlineLabel" v-model="univDeadlineObj.org_application_deadline_forstudent" class="form-control">
          <option disabled :value="null">Select Application Deadline For Student</option>
          <option :value="deadline" v-for="(i, deadline) of this.org_application_deadlineList[univDeadlineObj.university_id]" :key="deadline">{{i}}</option>
        </select>
      </div>
      <div class="mt-4">
        <b-btn type="button" variant="primary" class="pull-left" @click="editAdmission(univDeadlineObj)">
          {{cvAddAdmissionBtn}}
        </b-btn>
      </div>
    </b-modal><!--Applicable Deadline for this Student-->

    <!--Expanded Recommendation List -->
    <b-modal size="xxl" :title="expandedUnivRecoModalTitle" v-model="showExpandedUnivRecoList" no-close-on-backdrop no-close-on-esc @hide="closeExpandedUnivRecoModal()">
      <SpcmUnivList :key="refreshExpandedUnivRecoList" @emitOpenUnivListModal="openUnivListModal()" :propSpcmObj="propSpcmObj" />
      <template #modal-footer="">
        <b-button size="sm" class="pull-left" variant="secondary" @click="closeExpandedUnivRecoModal()">
          {{modalCancelBtnText}}
        </b-button>
      </template>
    </b-modal><!--Expanded Recomendation List -->

    <!--University List -->
    <b-modal size="xl" :title="univListModalTitle" v-model="showUnivList" no-close-on-backdrop no-close-on-esc @hide="closeUnivListModal()">
      <SpcmUnivList :propUserUnivReco="univRecoObjList" @emitAddUnivReco="emitAddUnivReco" />
      <template #modal-footer="">
        <b-button size="sm" class="pull-left" variant="secondary" @click="closeUnivListModal()">
          {{modalCancelBtnText}}
        </b-button>
      </template>
    </b-modal><!--University List -->

    <!-- Student Recommended University List -->
    <b-modal class="xxl" :title="studentUnivChoiceList" v-model="showStudentUniChoiceModal" no-close-on-backdrop no-close-on-esc hide-footer @hide="closeStudentUniChoiceModal">
      <form action="#">
        <div class="form-row">
          <div class="col-md-12 mb-3">
            <textarea
              v-model="vmOrganisationFormData.student_univ_choice"
              type="textarea"
              class="form-control textarea"
              required
            />
          </div><br>
          <button v-if="userData.user_role=='USERROLE11114'" type="button" class="btn btn-primary ml-1" @click="updateStudentUnivChoices(vmOrganisationFormData)">Save</button>
        </div>
      </form>
      <template #modal-footer="">
        <b-button size="sm" class="pull-left" variant="secondary" @click="closeStudentUniChoiceModal()">
          {{modalCancelBtnText}}
        </b-button>
      </template>
    </b-modal><!-- Student Recommended University List -->

    <!-- Place the component at the bottom of your main template -->
    <SingleFieldEdit
      :propEditConfig="editConfig"
      v-model="editConfig.show"
      :label="editConfig.label"
      :updateFieldKey="editConfig.updateFieldKey"
      :baseRecordId="editConfig.baseRecordId"
      :baseRecordKey="editConfig.baseRecordKey"
      :currentValue="editConfig.value"
      :inputType="editConfig.type"
      :apiFunction="updateAdmissionApi"
      @success="getUnivReco"
      :key="editConfig.label"
    />

    <!-- Modal for Editing Organisation -->
    <b-modal
      v-model="showOrgEditModal"
      size="xl"
      hide-footer
      title="Edit Organisation"
      body-class="p-0"
    >
      <OrganisationEdit
        v-if="showOrgEditModal"
        :prop-org-id="selectedOrgId"
        :prop-org-type="selectedOrgType"
        @save-success="getUnivReco"
        @closeModal="showOrgEditModal = false"
      />
    </b-modal>

    <b-modal v-model="showOrgAddModal"
      id="modal-add-org"
      title="Add Organization Info"
      hide-footer
      size="xl">

      <OrgProfileAdd v-if="showOrgAddModal"
        :propOrgDetails = this.orgDetails
        :propOpenedInModal="true"
        @emitCloseOrgProfileAddModal="closeOgProfileAdd"
      />
    </b-modal>

    <!-- <b-modal v-model="showModelAcceptConfirm" size="md" :title="acceptanceModalHeading" hide-header-close>
      <p>{{aceeptnaceDetail}}</p>
      <template #modal-footer="">
        <b-button size="sm" @click="showModelAcceptConfirm = false">
          Cancel
        </b-button>
        <b-button size="sm" variant="primary" @click="confirmAdmissionAcceptance()">
          Accept
        </b-button>
      </template>
    </b-modal> -->

    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>

<script>
import { Admissions } from "../../../FackApi/api/admission"
import ApiResponse from "../../../Utils/apiResponse"
import SpcmUnivList from "./SpcmUnivList.vue"
import { Spcms } from "../../../FackApi/api/Spcm.js"
import SingleFieldEdit from "./SingleFieldEdit.vue"
import { OrgProfiles } from "../../../FackApi/api/OrgProfile.js"
import OrganisationEdit from "../Organisation/OrganisationEdit.vue"
import OrgProfileAdd from "../Organisation/OrgProfile/OrgProfileAdd.vue"
import config from "../../../Utils/config.js"

export default {
  name: "SpcmStudentUnivReco",
  components: {
    SpcmUnivList,
    SingleFieldEdit,
    OrganisationEdit,
    OrgProfileAdd
  },
  data () {
    return {
      univRecoObjList: null,
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "Shortlisted Universities",
      univListModalTitle: "University List",
      showExpandedUnivRecoList: false,
      showStudentUniChoiceModal: false,
      showUnivList: false,
      expandedUnivRecoModalTitle: "Shortlisted Universities",
      modalCancelBtnText: "Cancel",
      refreshExpandedUnivRecoList: 0,
      studentUnivChoiceList: "Student Recommended University List",
      vmOrganisationFormData: {},
      org_application_deadlineList: {},
      org_application_deadline_forstudent: null,
      showDeadlineModel: false,
      cvDeadlineHeader: "UpdateDeadline",
      admissionStateInfo: config.AdmissionStateInfo,
      admissionStateInfoColors: config.AdmissionStateInfoColors,
      admissionStateNum: config.AdmissionStateNum,
      univCourseObj: {
        cour_id: null
      },
      cvAddAdmissionBtn: "Save",
      univDeadlineObj: {},
      editConfig: {
        show: false,
        label: "",
        updateFieldKey: "",
        baseRecordId: null,
        baseRecordKey: "",
        value: "",
        type: "text"
      },
      showOrgEditModal: false,
      selectedOrgId: null,
      selectedOrgType: null,
      univApplicationDeadlineLabel: "Choose the Applicable Deadline for this Student",
      showOrgAddModal: false,
      orgDetails: null,
      admState: null,
      // showModelAcceptConfirm: false,
      pendingAcceptUnivObj: null,
      // acceptanceModalHeading: "University Admission Acceptance",
      // aceeptnaceDetail: "Once saved, this cannot be changed. Please confirm if you are sure.",
      showStateModal: false,
      selectedUnivForStateChange: null,
      targetStateKey: null
    }
  },
  props: {
    propSpcmObj: {
      default: null,
      type: Object
    },
    propUserUnivReco: {
      type: Array,
      default: null
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    },
    /**
     * filteredAdmissionStates
     */
    filteredAdmissionStates () {
      const allowedKeys = ["STU_ADM_START", "STU_APP_DONE", "UNIV_APP_OFFER_SENT", "STU_APP_ACCEPTED", "UNIV_FINAL", "STU_ADM_REJECTED", "STU_APP_REJECTED", "UNIV_APP_REJECTED", "STU_APP_WITHDRAWN", "UNIV_APP_REJECTED"]
      if (!this.admissionStateInfo) return []

      return Object.keys(this.admissionStateInfo)
        .filter(key => allowedKeys.includes(key))
        .map(key => ({
          key: key,
          text: this.admissionStateInfo[key]
        }))
    }
  },
  mounted () {
    this.spcmView()
    this.getUnivReco()
  },
  methods: {
    /**
     * getMappedStateKey
     */
    getMappedStateKey (univObj) {
      if (!univObj) return "STU_ADM_START"

      const num = Number(univObj.adm_state_num) || this.admissionStateNum[univObj.adm_state] || 1

      if (num === 1) return "STU_ADM_START"
      if (num >= 2 && num <= 12) return "STU_APP_DONE"
      if (num === 13 || num === 14) return "UNIV_APP_OFFER_SENT"
      if (num === 15) return "STU_APP_ACCEPTED"
      if (num === 16) return "UNIV_FINAL"
      if (num === 17) return "STU_ADM_REJECTED"
      return univObj.adm_state || "STU_ADM_START"
    },
    /**
     * update Admission Api
     */
    async updateAdmissionApi (payload) {
      let res = await OrgProfiles.OrgProfileEdit(this, payload)
      if (res && res.resp_status) {
        return res
      }
      else {
        ApiResponse.responseMessageDisplay(this, res)
      }
    },
    /**
     * open Edit
     */
    openEdit (univObj, key, label, type = "text") {
      this.editConfig = {
        show: true,
        baseRecordId: univObj.org_id,
        baseRecordKey: "org_id",
        updateFieldKey: key,
        label: label,
        value: univObj[key],
        type: type
      }
    },
    /**
     * getUnivReco
     */
    async getUnivReco () {
      try {
        const payload = {}
        if (this.$route.params.spcmId) {
          payload.gide_user_id = this.propSpcmObj.user_id
          payload.user_role = "USERROLE11114"
          payload.module = "SPCM"
        }
        else {
          payload.gide_user_id = this.userData.user_id
          payload.user_role = this.userData.user_role
        }

        const admissionListResp = await Admissions.admission_dashboard(this, payload)
        if (admissionListResp.resp_status) {
          this.univRecoObjList = admissionListResp.resp_data.data
        }
        else {
          this.univRecoObjList = []
        }
      }
      catch (err) {
        console.error("Exception in getUnivReco and err: ", err.message)
      }
    },
    /**
     * addAdmission
     */
    async addAdmission (univObj) {
      try {
        const payload = {
          gide_user_id: this.propSpcmObj.user_id,
          university_id: univObj.university_id ? univObj.university_id : univObj.org_id,
          adm_fields: JSON.stringify({
            "cour_id": univObj.cour_id,
            "cour_name": univObj.cour_name,
            "batch": "Not yet decided",
            "cour_degree_name": univObj.cour_degree_name
          }),
          cour_id: univObj.cour_id,
          org_application_deadline_forstudent: univObj.org_application_deadline_forstudent,
          org_application_deadline_internal: univObj.org_application_deadline_internal,
          module: "SPCM",
          spcm_id: this.propSpcmObj.spcm_id,
          counselor_team: this.propSpcmObj.counselor_team,
          org_name: univObj.org_name
        }

        const admissionAddResp = await Admissions.admissionAdd(this, payload)
        if (admissionAddResp.resp_status) {
          this.getUnivReco()
          this.refreshExpandedUnivRecoList++
          this.$emit("refreshScholarshipReco")
        }
      }
      catch (err) {
        console.error("Exception in addAdmission and err: ", err.message)
      }
    },
    /**
     * openExpandedUnivRecoModal
     */
    openExpandedUnivRecoModal () {
      this.showExpandedUnivRecoList = true
    },
    /**
     * closeExpandedUnivRecoModal
     */
    closeExpandedUnivRecoModal () {
      this.showExpandedUnivRecoList = false
      this.getUnivReco()
    },
    /**
     * openUnivListModal
     */
    openUnivListModal () {
      this.showUnivList = true
    },
    /**
     * closeUnivListModal
     */
    closeUnivListModal () {
      this.showUnivList = false
    },
    /**
     * emitAddUnivReco
     */
    emitAddUnivReco (univObj) {
      this.addAdmission(univObj)
    },
    /**
     * removeUnivReco
     */
    async removeUnivReco (univObj) {
      try {
        const univRecoDeleteResp = await Admissions.admissionDelete(this, univObj.adm_id, true)
        if (univRecoDeleteResp.resp_status) {
          this.getUnivReco()
          this.$emit("refreshScholarshipReco")
          return
        }
        else {
          ApiResponse.responseMessageDisplay(this, univRecoDeleteResp)
        }
      }
      catch (err) {
        console.error("Exception in removeUnivReco() and err: ", err.message)
      }
    },
    /**
     * goTo URL
     */
    goToURL (orgObj) {
      window.open(orgObj.org_website, "_blank")
    },
    /**
     * goToUnivCoursePage
     */
    goToUnivCoursePage (courUrl) {
      window.open(courUrl, "_blank")
    },
    /**
     * openStudentUnivChoiceList
    */
    async openStudentUnivChoiceList (item) {
      this.showStudentUniChoiceModal = true
      this.StudentUniChoice = item
    },
    /**
     * updateStudentUnivChoice
     */
    async updateStudentUnivChoices (studentUniChoiceObj) {
      try {
        this.cvLoadingStatus = true

        let payload = {
          gide_user_id: this.propSpcmObj.user_id,
          spcm_id: this.propSpcmObj.spcm_id,
          student_univ_choice_list: studentUniChoiceObj.student_univ_choice
        }

        let spcmAddResp = await Spcms.spcmStudentUniversityEdit(this, payload)
        await ApiResponse.responseMessageDisplay(this, spcmAddResp)
        if (spcmAddResp && !spcmAddResp.resp_status) {
          return false
        }

        this.closeStudentUniChoiceModal()
      }
      catch (err) {
        console.error("Exception occurred at updateStudentUnivChoice() and Exception:", err.message)
      }
    },
    /**
     * closeStudentUniChoiceModal
    */
    closeStudentUniChoiceModal () {
      this.showStudentUniChoiceModal = false
    },
    /**
     *Accept/Rejected and Added Organisation
    */
    async student_univ_choice_status (univObj, status = 2) {
      let payload = {
        adm_id: univObj.adm_id,
        student_univ_choice_status: status
      }

      let univChoiceStatusResp = await Admissions.student_univ_choice_status(this, payload)
      if (univChoiceStatusResp.resp_status) {
        univObj.student_univ_choice_status = status
        this.getUnivReco()
        this.refreshExpandedUnivRecoList++
      }
      else {
        ApiResponse.responseMessageDisplay(this, univChoiceStatusResp)
      }
    },

    /**
     * spcmView
     */
    async spcmView () {
      try {
        let spcmId = this.propSpcmObj.spcm_id
        let spcmViewResp = await Spcms.spcmView(this, spcmId)
        if (spcmViewResp && spcmViewResp.resp_status) {
          this.vmOrganisationFormData.student_univ_choice = spcmViewResp.resp_data.data.student_univ_choice_list
        }
      }
      catch (err) {
        console.error("Exception occurred at spcmView() and Exception:", err.message)
      }
    },
    /**
     * getApplicationDeadlines
     * If the Data Application Deadline data is in JSON string then parse and format XXXX
     * else just format
     * If the it is found that a particular deadline is tagged to a student then highlight the option with color
     * Build an array of org specific deadlines for the ADMIN/COUNSELOR to choose and set for a stuent
     */
    getApplicationDeadlines (orgObj, responseWithHTMLTags = "TAGS") {
      try {
        let deadlines = orgObj.org_application_deadline
        let deadlinesObj = null
        let deadlineStr = ""

        let orgId = orgObj.org_id ? orgObj.org_id : orgObj.university_id
        orgObj.org_id = orgId
        if (!this.org_application_deadlineList[orgId]) {
          this.org_application_deadlineList[orgId] = {}
        }

        if (!deadlines) {
          if (responseWithHTMLTags == "TAGS") {
            deadlineStr += `<small>Deadlines Not Found</small><br>`
          }
          else {
            deadlineStr += `Deadlines Not Found\n`
          }
        }
        else if (deadlines.includes("{")) {
          deadlinesObj = JSON.parse(deadlines)
          for (const key in deadlinesObj) {
            let value = deadlinesObj[key]

            if (!value || value.includes("null")) {
              value = "--"
            }

            if (responseWithHTMLTags == "TAGS") {
              if (orgObj.org_application_deadline_forstudent && key.includes(orgObj.org_application_deadline_forstudent)) {
                deadlineStr += `<small class="information-color">${key}: <b>${value}</b></small><br>` // Required While Viewing
              }
              else {
                deadlineStr += `<small>${key}: ${value}</small><br>` // Required While Viewing
              }
            }
            else {
              deadlineStr += `${key}: ${value}\n`
            }

            this.org_application_deadlineList[orgObj.org_id][key] = key
          }
        }
        else {
          if (responseWithHTMLTags == "TAGS") {
            if (deadlines.includes("\n")) {
              deadlines = deadlines.replaceAll("\n", ",").replaceAll("\r", "")
            }
            let deadlinesArr = deadlines.split(",")

            let key = ""
            let value = ""

            for (let deadline of deadlinesArr) {
              deadline = deadline.trim()
              key = deadline.split(":")[0]
              value = deadline.split(":")[1]

              if (key.length <= 0) {
                continue
              }

              if (!value || value.includes("null")) {
                value = "--"
              }

              this.org_application_deadlineList[orgObj.org_id][key] = key

              if (orgObj.org_application_deadline_forstudent && key.includes(orgObj.org_application_deadline_forstudent)) {
                deadlineStr += `<small>${key}: <b>${value}</b></small><br>` // Required While Viewing
              }
              else {
                // deadlineStr += `<small>${key}: ${value}</small><br>` // Required While Viewing
              }
            }
          }
          else {
            deadlineStr += `${deadlines}\n`
          }
        }

        return deadlineStr
      }
      catch (e) {
        console.error("Ex. getApplicationDeadlines:", e)
      }
    },
    /**
     * editAdmission
     */
    async editAdmission (univObj) {
      try {
        const targetUnivId = univObj.university_id || univObj.org_id
        const dynamicStateNum = this.admissionStateNum[this.targetStateKey] || univObj.adm_state_num

        const payload = {
          user_id: this.propSpcmObj.user_id,
          adm_id: univObj.adm_id,
          university_id: targetUnivId,
          org_application_deadline_forstudent: univObj.org_application_deadline_forstudent,
          adm_state: this.targetStateKey || univObj.adm_state,
          adm_state_num: dynamicStateNum
        }

        const admissionEditResp = await Admissions.admissionEdit(this, payload)
        if (admissionEditResp.resp_status) {
          this.getUnivReco()
          if (this.refreshExpandedUnivRecoList !== undefined) this.refreshExpandedUnivRecoList++
          this.showDeadlineModel = false
        }
      }
      catch (err) {
        console.error("Exception in editAdmission and err: ", err.message)
      }
    },
    /**
     * Open State Change Modal
     */
    openStateChangeModal (univObj) {
      this.selectedUnivForStateChange = univObj
      this.targetStateKey = this.getMappedStateKey(univObj)
      this.showStateModal = true
    },
    /**
     * Submit State Change Handler
     */
    async submitStateChange () {
      try {
        if (!this.selectedUnivForStateChange || !this.targetStateKey) return

        const stateNum = this.admissionStateNum[this.targetStateKey]

        // Check if the target state is "UNIV_FINAL" (Final stage)
        if (this.targetStateKey === "UNIV_FINAL") {
          // Check if any other university in the list is already set to final state
          const hasExistingFinal = this.univRecoObjList && this.univRecoObjList.some(univ => {
            // Exclude the currently selected university from the check
            if (univ.adm_id === this.selectedUnivForStateChange.adm_id) return false
            return this.getMappedStateKey(univ) === "UNIV_FINAL"
          })

          if (hasExistingFinal) {
            this.toastMsg = "Only one university can be set to final stage."
            this.toastVariant = "danger"
            this.showToast = true
            return
          }
        }

        const payload = {
          user_id: this.propSpcmObj.user_id,
          adm_id: this.selectedUnivForStateChange.adm_id,
          university_id: this.selectedUnivForStateChange.university_id || this.selectedUnivForStateChange.org_id,
          adm_state: this.targetStateKey,
          adm_state_num: stateNum
        }

        const res = await Admissions.admissionEdit(this, payload)
        if (res.resp_status) {
          this.getUnivReco()
          if (this.refreshExpandedUnivRecoList !== undefined) this.refreshExpandedUnivRecoList++
          this.showStateModal = false
        }
        else {
          ApiResponse.responseMessageDisplay(this, res)
        }
      }
      catch (err) {
        console.error("Exception in submitStateChange: ", err.message)
      }
    },
    /**
     * openUnivDeadlineModal
     */
    openUnivDeadlineModal (univObj) {
      this.showDeadlineModel = true
      this.univDeadlineObj = univObj
    },
    /**
     * goToOrganisationEdit
     */
    goToOrganisationEdit (univObj) {
      this.selectedOrgId = univObj.org_id
      this.selectedOrgType = univObj.type
      this.showOrgEditModal = true
    },
    closeOgProfileAdd (univData) {
      this.getUnivReco()
    },
    goToAddOrgProfile (univObj) {
      this.showOrgAddModal = true
      this.orgDetails = univObj
    },
    isDataCardVisible (value) {
      return ((this.userData.user_role === "USERROLE11114" && value !== null && value !== "null" && value.length > 0) || this.userData.user_role == "USERROLE11111" || this.userData.user_role == "USERROLE11118")
    }
  }
}
</script>

<style>
ul li::marker {
  color: red;
}
ol li::marker {
  color: #000;
}
.textarea {
  min-height: 150px;
  line-height: 27px !important;
}
.check_icon{
  border: 2px solid;
  border-radius: 100%;
  padding: 1px 2px 2px 2px;
  margin-top: 3px;
  font-size: 10px;
  margin-right: 7px;
}
.cart_icon{
  font-size: 20px;
  position: relative;
  top: -3px;
}
.detail_card {
  display: -webkit-box;
  -webkit-line-clamp: 9;
  -webkit-box-orient: vertical;
  overflow-y: auto;
  line-height: 1.6;
  width: 100%;
}
.btn-success{
  background-color: green !important;
  border-color: green !important;
}
.btn-blue-button{
  background-color: blue !important;
  border-color: blue;
  color: #fff;
}
.btn-blue-button:hover{
  color: #fff;
}
div span.bg-light-warning{
  color: #fff !important;
  background-color: rgb(220, 147, 11) !important;
  border-color: rgb(220, 147, 11) !important;
}
.disabled-icon {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}
.badge{
  line-height: 1 !important;
}
.uniDetail {
  margin-bottom:0px;
  font-weight: 600;
  color: #e5252c;
}
</style>
